import {initAccordions} from '$c3base/accordion.js';

initAccordions();


function mobileMenu() {
    let headerContentWidth = 0,
        headerWidth = document.querySelector('.page-header-inner').offsetWidth;
    document.querySelectorAll('.page-header-inner > div').forEach(el => {
        headerContentWidth += el.offsetWidth;
    })
    document.querySelector('.page-header').classList.toggle('header-mobile', (headerContentWidth > headerWidth));
}

mobileMenu();
window.addEventListener('resize', () => {
    mobileMenu();
})


if (localStorage.getItem('corona') == null || localStorage.getItem('corona') === undefined) {
    localStorage.setItem('corona', false);
}
if (!document.querySelector('.header-banner')) {
    document.querySelector('main').style.marginTop = "160px"
}

function sameHeight(selector) {
    let $contentList = document.querySelectorAll(selector);
    let contentListHeight = 0;
    $contentList.forEach(el => {
        if (el.clientHeight > contentListHeight) {
            contentListHeight = el.clientHeight;
        }
    });
    $contentList.forEach(el => {
        el.style.height = contentListHeight + 'px'
    })
}

sameHeight('.booking-tile .content-list');
sameHeight('.booking-tile .content-wrap h3');

function couponForm() {

    let value = document.querySelector('#powermail_field_gutscheinart').value;
    if (value) {
        switch (value) {
            case "Angebotsgutschein": {
                let fieldset = document.querySelector('.powermail_fieldset_15');
                fieldset.classList.add('shown');
                fieldset.parentNode.querySelectorAll('.powermail_fieldset_16, .powermail_fieldset_17').forEach(f => f.classList.remove('shown'));
                break;
            }
            case "Wertgutschein": {
                let fieldset = document.querySelector('.powermail_fieldset_16');
                fieldset.classList.add('shown');
                fieldset.parentNode.querySelectorAll('.powermail_fieldset_15, .powermail_fieldset_17').forEach(f => f.classList.remove('shown'));
                break;
            }
            case "Übernachtungsgutschein": {
                let fieldset = document.querySelector('.powermail_fieldset_17');
                fieldset.classList.add('shown');
                fieldset.parentNode.querySelectorAll('.powermail_fieldset_15, .powermail_fieldset_16').forEach(f => f.classList.remove('shown'));
                break;
            }
        }
    }

}

if (document.querySelector('#powermail_field_gutscheinart')) {
    document.querySelector('#powermail_field_gutscheinart').addEventListener('change', function () {
        couponForm();
    });
    couponForm();
}

document.querySelectorAll('figcaption').forEach(fc=>{

        let colParent = fc.closest('.row > div');
        let h = fc.clientHeight + 10;
        colParent.style.marginBottom =  h + "px";
        fc.style.bottom= -1 * (h - 5) + "px"

        fc.closest('.row > div').style.overflow = "visible";
        fc.closest('.frame-type-image').style.overflow= "visible"
})


document.querySelectorAll('.popup').forEach(popup => {
console.log(sessionStorage.getItem('corona'))
    if (sessionStorage.getItem('corona') !== 'true') {
        popup.style.display = "block";
    }
    popup.addEventListener('click',function () {
        sessionStorage.setItem('corona', 'true');
        popup.style.display = "none";
    });

    document.querySelectorAll('.corona-news').forEach(cn=>function () {
        popup.style.display = "block";
    })
});




// $(function(){
//
//     if ($('.accordion-outer-wrap').length) {
//         $('.accordion-outer-wrap').each(function () {
//             $(this).accordion({
//                 collapsible: true,
//                 heightStyle: 'content',
//                 active: false,
//                 activate: function( event, ui ) {
//                     if(!$.isEmptyObject(ui.newHeader.offset())) {
//                         $('html:not(:animated), body:not(:animated)').animate({ scrollTop: ui.newHeader.offset().top }, 'slow');
//                     }
//                 }
//             });
//         })
//     }
